"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BooleanCell = exports.BooleanCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var icon_1 = require("../elements/icon");
var badge_1 = require("../elements/badge");
exports.BooleanCellDefaultProps = {
  value: false,
  iconColor: "text",
  iconSize: 24
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    color: ", ";\n  "], ["\n    display: flex;\n    justify-content: center;\n    color: ", ";\n  "])), theme_1.theme.COLOR('text-subtle')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props._size && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), props._size, props._size);
  })
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(11))
});
var BadgeFalseStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-style: dotted;\n    color: #ccc;\n    font-size: ", ";\n  "], ["\n    border-style: dotted;\n    color: #ccc;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(11))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  BadgeFalse: (0, styled_components_1.default)(badge_1.Badge)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BadgeFalseStyles)
};
var BooleanCell = function (props) {
  var className = props.className,
    value = props.value,
    iconColor = props.iconColor,
    iconSize = props.iconSize;
  var icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  // const renderTrue = props.renderTrue || (({ value, icons }) => <My.Icon _size={iconSize} color={iconColor}><icons.TickCircle /></My.Icon>);
  // const renderFalse = props.renderFalse || (({ value, icons }) => '( no )');
  var renderTrue = props.renderTrue || function (_a) {
    var value = _a.value;
    return react_1.default.createElement(My.Badge, null, t('yes'));
  };
  var renderFalse = props.renderFalse || function (_a) {
    var value = _a.value;
    return react_1.default.createElement(My.BadgeFalse, {
      isPending: true
    }, t('no'));
  };
  var render = !!value ? renderTrue : renderFalse;
  return react_1.default.createElement(My.Container, {
    className: className
  }, render({
    value: value,
    icons: icons,
    t: t
  }));
};
exports.BooleanCell = BooleanCell;
exports.BooleanCell.defaultProps = exports.BooleanCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;